import AccountingInfoOption from './AccountingInfoOption';

export default class TransportationType extends AccountingInfoOption {
    public static entity = 'transportationTypes';
    public static apiType = 'transportation-types';
    public static storageKey = 'transportation_types_list';
}